import React from 'react';

interface ModelSwitchModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  language: string;
  message?: string;
}

export const ModelSwitchModal: React.FC<ModelSwitchModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  language,
  message: customMessage
}) => {
  if (!isOpen) return null;

  const message = customMessage || (language === 'es'
    ? 'Para procesar imágenes, necesitamos cambiar a un modelo con capacidades de visión.'
    : 'To process images, we need to switch to a vision-capable model.');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">
          {message}
        </h3>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
          >
            {language === 'es' ? 'Cancelar' : 'Cancel'}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md"
          >
            {language === 'es' ? 'Continuar' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};